

//判断是否有http或者https 
/**
 * @param {String} url 图片地址
 * */
 // domainName = '', url = ''
export const imageHttp = (url) => {
	let qnUrl = localStorage.getItem('qiniu')
	let pic = ''
	if(url && url != ''){
		if (url.startsWith('http')) return url;
		pic = `${qnUrl}/${url}`
	}
	return pic
}
/**
*  @param {String} url 图片地址
* */ 
export const previewPic = (url) => {
	let qnUrl=localStorage.getItem('qnUrl')
	// let s = {1: "mall/images/2021/10/13/1634103319551.jpg"}
	let pic = [] 
	// console.log(url)
	if(typeof url == 'object' && url.length > 0){
		url.forEach(item => {
			if (item.startsWith('http')) return item;
			pic.push(`${qnUrl}/${item}`)
			
		})
	}else{
		if(url && url.length == 1){
			if (url[0].startsWith('http')) return url[0];
			pic.push(`${qnUrl}/${url[0]}`)
			// console.log(pic)
		}
	}
	return pic
}
/**
* 	@param {String} num 数字
**/
// 获取时间带时分秒的
export const toChinesNum = (num) =>{
	let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; 
	let unit = ["", "十", "百", "千", "万"];
		num = parseInt(num);
	let getWan = (temp) => {
	let strArr = temp.toString().split("").reverse();
	let newNum = "";
		for (var i = 0; i < strArr.length; i++) {
			newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
		}
		return newNum;
	}
	let overWan = Math.floor(num / 10000);
	let noWan = num % 10000;
	if (noWan.toString().length < 4) {
		noWan = "0" + noWan;
	}
	return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
}
/**
 * date(new Date) -> "2018-07-23" 
 * @param {String} num 时间戳， delimiter 分隔符号
**/ 
// 日期转换带时间
export const myDate = ( date,delimiter)=>{
		let myTime = new Date(parseInt(date))
		// console.log(myTime)
		// 年
		let Y = myTime.getFullYear()
		// 月
		let M = myTime.getMonth()+1
			M = M<10?'0'+ M:M
		// 日
		let D = myTime.getDate()
			D = D<10?'0'+ D:D
		// 时
		let h = myTime.getHours()
			h = h<10?'0'+ h:h
		// 分
		let f = myTime.getMinutes()
			f = f<10?'0'+ f:f
		//秒
		let m = myTime.getSeconds()
			m = m<10?'0'+ m:m
		return Y + delimiter + M + delimiter + D +' ' + h+ ' '+':'+'  '+ f 
}

 // 曝光函数出去 在需要用得地方引入这个文件 { yyyymmdd } 这种方式引入 yyyymmdd() // 直接传入参数
export const handleTime = (date, delimiter = '-')=> { 
	if(date){
		const yyyy = date.getFullYear().toString();
		const mm = (date.getMonth() + 1).toString();
		const dd = date.getDate().toString();
		// 时
		let h = date.getHours().toString();
			  h = h<10?'0'+ h:h
		// 分
		let f = date.getMinutes().toString();
			f = f<10?'0'+ f:f
		//秒
		let m = date.getSeconds().toString();
			m = m<10?'0'+ m:m
		return yyyy + delimiter + (mm[1] ? mm : `0${mm[0]}`) + 
		delimiter + (dd[1] ? dd : `0${dd[0]}`)+' '+ h +':' + f +':'+ m;
	}else{
		return ''
	}		
}

